import { http } from '../utils/axios';
import { IProject } from 'shared/interfaces/project.interface';

class ProjectsService {
  private static instance: ProjectsService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static getInstance(): ProjectsService {
    if (!ProjectsService.instance) {
      ProjectsService.instance = new ProjectsService();
    }

    return ProjectsService.instance;
  }

  public getAllProjects = async () => {
    const { data } = await http<IProject[]>({
      url: '/projects',
      method: 'GET'
    });

    return data;
  };
}

const instance = ProjectsService.getInstance();

export default instance;
